import { Link } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import FeedbackForm from "./components/FeedbackForm";

const SCOPE = [
  {
    icon: "ri-government-line",
    title: "社会爆料",
    desc: "城市更新、公共交通、消费维权与民生政策落地过程中的现场细节，优先收录可核实的公开信息。",
  },
  {
    icon: "ri-movie-2-line",
    title: "娱乐爆料",
    desc: "明星动态、影视综艺排播与行业合约的公开进展，标注消息来源与时间线，不做无依据推测。",
  },
  {
    icon: "ri-folder-open-line",
    title: "专题追踪",
    desc: "把同一事件的碎片信息按时间顺序串起来，出现官方通报时同步补充，方便你一次读完前因后果。",
  },
];

const PRINCIPLES = [
  { title: "先核实，再发布", desc: "至少两个独立来源，或一份可查验的书面材料。" },
  { title: "标注不确定性", desc: "尚未证实的说法会在正文中明确写出，不做结论式表达。" },
  { title: "保护线索来源", desc: "默认匿名，未经提供者同意不公开任何可识别信息。" },
  { title: "保留更正记录", desc: "内容出现偏差时在原条目内更正，并说明修改时间。" },
];

export default function AboutPage() {
  useDocumentMeta({
    title: "关于我们 - 爆料网",
    description:
      "了解爆料网的定位、内容范围与编辑原则，查看联系方式并提交你掌握的社会或娱乐线索。",
    keywords: "爆料网,关于我们,联系方式,线索提交,社会爆料,娱乐爆料",
  });

  return (
    <PageLayout>
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 pt-5 md:pt-7">
        <nav className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
          <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">
            首页
          </Link>
          <i className="ri-arrow-right-s-line text-foreground-300" />
          <span className="text-foreground-800">关于我们</span>
        </nav>

        <header className="mt-4 rounded-lg border border-background-200/80 bg-background-100 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr] gap-0">
            <div className="p-6 md:p-9">
              <p className="font-label text-xs tracking-[0.26em] text-primary-600">ABOUT BAOLIAO</p>
              <h1 className="mt-3 text-[28px] md:text-[36px] leading-tight font-black text-foreground-950">
                把现场记录下来，
                <br className="hidden sm:block" />
                也把回应放在同一页
              </h1>
              <p className="mt-4 max-w-[560px] text-sm md:text-[15px] leading-8 text-foreground-600">
                爆料网关注社会热点与娱乐动态，服务那些希望在信息还没被整理成通稿之前，先看到原始素材的读者。
                我们不追逐情绪，只把时间、地点、当事人说法与官方回应按顺序摆清楚。
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <a
                  href="#feedback"
                  className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-line" />
                  提交线索
                </a>
                <Link
                  to="/category/society"
                  className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  看看最近在爆什么
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
            <div className="border-t lg:border-t-0 lg:border-l border-background-300/60 bg-background-50 p-6 md:p-7 grid grid-cols-2 gap-5 content-center">
              {[
                { value: "2", label: "内容栏目" },
                { value: "6", label: "进行中专题" },
                { value: "29", label: "在库爆料" },
                { value: "24h", label: "更新频率" },
              ].map((stat) => (
                <div key={stat.label}>
                  <p className="font-label text-[32px] leading-none text-primary-600">{stat.value}</p>
                  <p className="mt-2 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </header>

        <section className="mt-10">
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-5 rounded-full bg-primary-500" />
            <h2 className="text-xl md:text-[22px] font-black text-foreground-950">我们报道什么</h2>
          </div>
          <div className="mt-5 grid grid-cols-1 md:grid-cols-3 gap-4">
            {SCOPE.map((item, index) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200/80 bg-background-50 p-5"
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`w-11 h-11 flex items-center justify-center rounded-lg text-xl ${
                      index === 0
                        ? "bg-primary-100 text-primary-600"
                        : index === 1
                          ? "bg-accent-100 text-accent-700"
                          : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    <i className={item.icon} />
                  </span>
                  <span className="font-label text-2xl text-background-300">
                    {`${index + 1}`.padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-4 text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-[13px] leading-7 text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-10 grid grid-cols-1 lg:grid-cols-[1.15fr_1fr] gap-5">
          <div className="rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-7">
            <h2 className="text-xl font-black text-foreground-950">编辑原则</h2>
            <p className="mt-2 text-sm leading-6 text-foreground-500">
              这四条是我们处理每一条线索时的底线，也欢迎你据此监督我们的内容。
            </p>
            <div className="mt-5 space-y-4">
              {PRINCIPLES.map((item, index) => (
                <div key={item.title} className="flex gap-3">
                  <span className="w-6 h-6 shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs font-bold">
                    {index + 1}
                  </span>
                  <div>
                    <h3 className="text-sm font-bold text-foreground-900">{item.title}</h3>
                    <p className="mt-1 text-[13px] leading-6 text-foreground-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-200/80 bg-background-100 p-5 md:p-7">
            <h2 className="text-xl font-black text-foreground-950">联系方式</h2>
            <p className="mt-2 text-sm leading-6 text-foreground-500">
              线索与版权事务请分别联系我们，工作时段内一般会在一个工作日内回复。
            </p>
            <div className="mt-5 space-y-3">
              {[
                { icon: "ri-mail-line", label: "线索邮箱", value: "tip@baoliao.example" },
                { icon: "ri-copyright-line", label: "版权与法务", value: "legal@baoliao.example" },
                { icon: "ri-wechat-line", label: "微信", value: "baoliao_news" },
                { icon: "ri-time-line", label: "受理时间", value: "每日 09:00 - 23:00" },
              ].map((row) => (
                <div
                  key={row.label}
                  className="flex items-center gap-3 rounded-md bg-background-50 px-3.5 py-3"
                >
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                    <i className={row.icon} />
                  </span>
                  <div className="min-w-0">
                    <p className="text-[11px] text-foreground-400">{row.label}</p>
                    <p className="text-sm text-foreground-900 truncate">{row.value}</p>
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-4 text-[11px] leading-5 text-foreground-400">
              以上联系方式与邮箱均为演示信息，不对应真实收件地址。
            </p>
          </div>
        </section>

        <section id="feedback" className="mt-10 scroll-mt-24 grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-5 items-start">
          <FeedbackForm />
          <aside className="space-y-4">
            <div className="rounded-lg border border-primary-200 bg-primary-50 p-5">
              <h3 className="text-base font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-600" />
                提交前请确认
              </h3>
              <ul className="mt-3 space-y-2.5 text-[13px] leading-6 text-foreground-600">
                <li className="flex gap-2">
                  <i className="ri-check-line text-primary-500 mt-0.5" />
                  尽量写明时间、地点与可核查的细节
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line text-primary-500 mt-0.5" />
                  请勿提交他人隐私信息与未公开的个人资料
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line text-primary-500 mt-0.5" />
                  图片与视频会在核实阶段单独联系索取
                </li>
              </ul>
            </div>
            <div className="rounded-lg border border-background-200/80 bg-background-100 p-5">
              <h3 className="text-base font-bold text-foreground-950">关于演示数据</h3>
              <p className="mt-2 text-[13px] leading-7 text-foreground-600">
                本站所有爆料、人物与联系方式均为演示内容，与真实事件无关。反馈表单为可正常提交的表单服务，
                不会展示虚假的成功状态。
              </p>
            </div>
          </aside>
        </section>

        <section className="mt-10 rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-7">
          <h2 className="text-lg font-black text-foreground-950">免责声明</h2>
          <p className="mt-2 text-[13px] leading-7 text-foreground-600 max-w-[960px]">
            爆料网所载内容仅用于信息交流与演示，不构成对任何个人或机构的定性判断。转载或引用请注明来源，
            不得断章取义。若你认为某条内容侵犯了你的合法权益，可通过上方版权邮箱与我们联系，我们将在核实后处理。
          </p>
        </section>
      </div>
    </PageLayout>
  );
}